<template>
  <div class="hp-manager-page-list" ref="mainList">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
      <span slot="button" v-if="permissionChecker('BomProduct.Edit')">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span>
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="handleEdit(1,rowKey.data)" :disabled="!permissionChecker('BomProduct.Edit')">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleRelation(rowKey.data)">销售范围</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handlePackage(rowKey.data)" :disabled="!rowKey.data.isBom">子件</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="deldata(rowKey.data)" :disabled="!permissionChecker('BomProduct.Edit')">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </template>
      <template slot="statusSwitch" slot-scope="rowKey">
        <span>
          <a-switch :checked="rowKey.data.isActive && rowKey.data.isErpActive" @change="activeChange(rowKey.data)" :disabled=" !permissionChecker('BomProduct.ActiveOpt')" />
        </span>
      </template>
      <template slot="statusSwitch2" slot-scope="rowKey">
        <span>
          <a-switch :checked="rowKey.data.isSalesInFront" @change="SetProductSalesInFront(rowKey.data)" :disabled="rowKey.data.isActive==false || !permissionChecker('BomProduct.ActiveOpt')" />
        </span>
      </template>

    </standard-table>
    <hp-manager-modal :title="params.productName+'  销售范围'" v-model="addOrgVisible" width="1200px">
      <hp-manager-page-relation-list slot="slot" @submit-success="refreshCurrent" @cancel="addOrgVisible = false" :paramsX="params"></hp-manager-page-relation-list>
    </hp-manager-modal>
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-product-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-product-add>
    </hp-manager-modal>
    <hp-manager-modal :title="params.productName+'  子件明细'" v-model="packageListVisible" width="1200px">
      <hp-manager-page-package-list slot="slot" @submit-success="refreshCurrent" @cancel="packageListVisible = false" :paramsX="params"></hp-manager-page-package-list>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";
import hpManagerPageRelationList from "./RelationOrgList";
import hpManagerPageProductAdd from "./Add";
import hpManagerPagePackageList from "./PackageList";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageRelationList,
    hpManagerPageProductAdd,
    hpManagerPagePackageList
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "ProductName",
          name: "产品名称"
        },
        {
          type: "input",
          key: "ProductCode",
          name: "产品编码"
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 120,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "产品编码",
          dataIndex: "productCode",
          width: 150,
          sorter: true
        },
        {
          title: "产品名称",
          dataIndex: "productName",
          width: 300,
          sorter: true
        },
        {
          title: "规格属性",
          dataIndex: "specDes"
        },
        {
          title: "产品系列",
          dataIndex: "productSeriesName",
          width: 150
        },
        {
          title: "产品分类",
          dataIndex: "productCategoryName",
          width: 150
        },
        {
          title: "单位",
          dataIndex: "measureUnitName",
          width: 80
        },
        {
          title: "预计交期(天)",
          dataIndex: "expectedDelivery",
          width: 130,
          sorter: true
        },
        {
          title: "上架状态",
          dataIndex: "isActive",
          width: 100,
          scopedSlots: { customRender: "status" }
        },
        {
          title: "前台销售",
          dataIndex: "isSalesInFront",
          width: 100,
          scopedSlots: { customRender: "status2" }
        },
        {
          title: "修改时间",
          dataIndex: "creationTime",
          width: 160,
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { ProductName: "", ProductCode: "", isActive: "" },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      addOrgVisible: false,
      packageListVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "1300px",
      title: ""
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
  },

  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.ProductName = p.values.ProductName;
      this.filterdata.ProductCode = p.values.ProductCode;
      this.filterdata.isActive = p.values.isActive;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },

    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑促销套装";
      } else if (type == 2) {
        this.title = "促销套装详情";
        this.isabl = true;
      } else {
        this.title = "新增促销套装";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    async activeChange(record) {
      let active = await api.ActiveProduct({ id: record.id });
      this.refreshCurrent();
    },
    async SetProductSalesInFront(record) {
      let active = await api.SetProductSalesInFront({ id: record.id });
      this.refreshCurrent();
    },
    handleRelation(record) {
      this.params = record;
      this.addOrgVisible = true;
    },
    handlePackage(record) {
      this.params = record;
      this.packageListVisible = true;
    },

    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DeleteBomProduct({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },

    refreshCurrent() {
      //  this.pagination.current = 0;
      this.addVisible = false;
      this.addOrgVisible = false;
      this.packageListVisible = false;
      //  this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetBomProductList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Goods/BomProduct/List.vue